import { cn } from '@/lib/utils'
import type { Route } from '@/routes'
import { RolesMatch } from '@trinity/blockchain-management'
import type { FC } from 'react'
import { NavLink as RouterNavLink } from 'react-router-dom'
import { RoleGuard } from '../role-guard'

interface Props {
    children: React.ReactNode
    route: Route
    className?: string
    onClick?: () => void
}

const NavLinkContent: FC<Props> = ({ children, route, className, onClick }) => {
    return (
        <RouterNavLink
            to={route.path}
            className={({ isActive }) =>
                cn(
                    'flex items-center gap-2 text-nav-text',
                    isActive && 'text-nav-text-active [&>svg_*]:stroke-nav-text-active',
                    'flex flex-row gap-[0.375rem] font-medium text-lg',
                    'hover:bg-nav-hover rounded-[0.5rem] p-2',
                    'transition-all',
                    '[&>svg_*]:transition-all',
                    className,
                )
            }
            onClick={onClick}
        >
            {children}
        </RouterNavLink>
    )
}

export const NavLink: FC<Props> = ({ children, route, className, onClick }) => {
    const { requiresRoles } = route
    const { roles = [], match = RolesMatch.All } = requiresRoles || {}

    return (
        <RoleGuard roles={roles} match={match} unauthorizedElement={null}>
            <NavLinkContent route={route} className={className} onClick={onClick}>
                {children}
            </NavLinkContent>
        </RoleGuard>
    )
}
